import React from 'react'
import './index.css'

type ContainerProps = {
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export const Container = ({ className = '', style, children }: ContainerProps) => (
  <div className={`Container--root ${className}`} style={style}>
    {children}
  </div>
)
